// "Lembrar de mim": guarda dados não-sensíveis do último login (nunca a senha)
// para a tela de boas-vindas. Limpável pelo usuário ("entrar com outra conta").
export interface RememberedUser {
  name: string;
  email: string;
  avatar?: string;
}

const KEY = 'bz_remember';

export function getRemembered(): RememberedUser | null {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as RememberedUser) : null;
  } catch {
    return null;
  }
}

export function setRemembered(u: RememberedUser) {
  localStorage.setItem(KEY, JSON.stringify(u));
}

export function clearRemembered() {
  localStorage.removeItem(KEY);
}
